import { CalendarInspectionType } from '../../enums/events-calendar.enum'
import {
  IGetCalendarEventsRequest,
  IGetTasksRequest,
  IUpsertCalendarEventRequest,
  IUpsertTaskRequest
} from '../../interfaces/events-calendar.interface'

export class GetCalendarUsers {
  static readonly type = '[EventsCalendar] Get Users'
}

export class GetCalendarEvents {
  static readonly type = '[EventsCalendar] Get Events'
  constructor(public payload: IGetCalendarEventsRequest) {}
}

export class GetCalendarTasks {
  static readonly type = '[EventsCalendar] Get Open Tasks'
  constructor(public payload: IGetTasksRequest) {}
}

export class GetCompletedCalendarTasks {
  static readonly type = '[EventsCalendar] Get Completed Tasks'
  constructor(public payload: IGetTasksRequest) {}
}

export class CreateCalendarTask {
  static readonly type = '[EventsCalendar] Create Task'
  constructor(public payload: IUpsertTaskRequest) {}
}

export class UpdateCalendarTask {
  static readonly type = '[EventsCalendar] Update Task'
  constructor(
    public taskId: string,
    public payload: IUpsertTaskRequest
  ) {}
}

export class CreateCalendarEvent {
  static readonly type = '[EventsCalendar] Create Event'
  constructor(public payload: IUpsertCalendarEventRequest) {}
}

export class UpdateCalendarEvent {
  static readonly type = '[EventsCalendar] Update Event'
  constructor(
    public eventId: string,
    public payload: IUpsertCalendarEventRequest
  ) {}
}

export class DeleteCalendarEvent {
  static readonly type = '[EventsCalendar] Delete Event'
  constructor(public eventId: string) {}
}

export class ToggleCalendarEventTask {
  static readonly type = '[EventsCalendar] Toggle Task Status'
  constructor(
    public taskId: string,
    public isCompleted: boolean
  ) {}
}

export class DeleteCalendarEventTask {
  static readonly type = '[EventsCalendar] Delete Task'
  constructor(public taskId: string) {}
}

export class LinkCalendarEventInspectionForm {
  static readonly type = '[EventsCalendar] Link Inspection Form'
  constructor(
    public eventId: string,
    public inspectionType: CalendarInspectionType,
    public formId: string
  ) {}
}

export class GetCalendarEventByForm {
  static readonly type = '[EventsCalendar] Get Event By Form'
  constructor(public formId: string) {}
}
